// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"112f0331","821":"73b9a76e"}[chunkId] + ".chunk.js";
};